module.exports = __webpack_public_path__ + "img/audio-detail-null.a33913cc.png";